// Module: cx.js
// Purpose: Tiny className combiner for the DS primitives — joins truthy parts,
//          skips falsy (false/undefined/"") so `cond && "class"` reads cleanly.

export const cx = (...parts) => parts.filter(Boolean).join(" ");

export default cx;
